export { default as configShape } from './configShape';
export { default as injectConfig } from './injectConfig';
export { default as ConfigProvider } from './ConfigProvider';
